import { defineComponent } from 'vue'

export const NonCautionView = defineComponent({
  setup () {
    return () => (
      <div>
        <div class="flex flex-col items-center">
          <div class="w-24 h-24 mb-4">
            <img src="https://fortynamo.appspot.com.storage.googleapis.com/mindle-client/community/assets/minder.png" />
          </div>
          <h2 class="font-bold mb-4 text-center">
            현재 주의, 심각 수준에
            <br />
            해당하는 캐릭터가 없습니다
          </h2>
        </div>
        <ul class="mt-4 text-sm leading-6 font-bold">
          <li class="ml-6 mb-2">
            <span class="text-[#f98360] -ml-6 mr-3">●</span>
            마인들링과 함께 지금처럼 악동들을 잘 관리해 주세요. 그런데 “어? 나
            지금 힘든데 왜 악동이 없지?” 라는 생각이 들 수 있어요.
          </li>
          <li class="ml-6">
            <span class="text-[#f98360] -ml-6 mr-3">●</span>이 경우는 반복적인
            삶의 어려움을 만드는 악동은 뚜렷하지 않지만, 최근의 상황으로 인해
            스트레스를 겪을 수 있어요. 이럴 땐 관심이 가는 악동의 스타터
            프로그램을 통해 마음 건강 기본기를 다져주시면 도움이 됩니다.
          </li>
        </ul>
      </div>
    )
  },
})
